export default __webpack_public_path__ + "static/media/polaris-logo.8a4347e2.png";